<template>
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
            <v-btn
                v-bind="$attrs"
                v-on="{...on,...$listeners}"
                dark
                fab
                small
                :color="color + ' darken-1'"
            >
                <v-icon>save_alt</v-icon>
            </v-btn>
        </template>
        <span>Export graph as png file</span>
    </v-tooltip>
</template>

<script>

export default {
    name: "ExportToPngButton",
    props: {
        color: {
            type: String,
            requred: true
        }
    }
}
</script>
